import React, { useState, Fragment } from "react";
import { t } from "i18next";
import InnerNav from "components/InnerNav/InnerNav";
import PageLayout from "layout/PageLayout/PageLayout";
import EmailSetting from "../EmailSetting/EmailSetting";
import BudgetSetting from "../BudgetSetting/BudgetSetting";
import CampaignActivationEmail from "../../CampaignActivationEmail/CampaignActivationEmail"; 
import NotificationEmail from "../NotificationEmail/NotificationEmail";
interface EmailNavProps {
  currentAppKey: any;
  updateCurrentAppKey: () => void;
}

const EmailNav: React.FC<EmailNavProps> = ({ currentAppKey, updateCurrentAppKey }) => {
  const [currentKey, setCurrentKey] = useState("1"); 

  const menuItems = [
    { label: t("emailSettingLabel"), key: "1" },
    { label: t("budgetSettingLabel"), key: "2" },
    { label: t("campaignActivationEmailLabel"), key: "4" },
    { label: t("notificationEmailsLabel"), key: "3" },

  ];

  // Helper to render selected tab content
  const renderContent = () => {
    switch (currentKey) {
      case "1":
        return <EmailSetting currentAppKey={currentAppKey} updateCurrentAppKey={updateCurrentAppKey} />;
      case "2":
        return <BudgetSetting currentAppKey={currentAppKey} updateCurrentAppKey={updateCurrentAppKey} />;
        case "3":
          return <NotificationEmail/>;
      case "4":
        return <CampaignActivationEmail currentAppKey={currentAppKey} updateCurrentAppKey={updateCurrentAppKey} />;
      default:
        return null;
    }
  };

  return (
    <Fragment>
      <PageLayout className="app-setting-container">
        <div className="app-setting-nav">
          <InnerNav
            theme="light"
            onTabClick={(e) => setCurrentKey(e.key)}
            selected={currentKey}
            menu={menuItems}
          />
        </div>

        <div className="mt-3 col-md-7 col-12">{renderContent()}</div>
      </PageLayout>
    </Fragment>
  );
};

export default EmailNav;
